import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function HeritagePage() {
  const { slug } = useParams();
  const [list, setList] = useState([]);
  const [article, setArticle] = useState(null);

  useEffect(() => {
    if (slug) { api.get(`/heritage/${slug}`).then((r) => setArticle(r.data)); }
    else { setArticle(null); api.get("/heritage").then((r) => setList(r.data)); }
  }, [slug]);

  if (slug && article) {
    return (
      <article className="min-h-screen pt-24">
        <div className="relative h-[42vh] overflow-hidden">
          <img src={article.image} alt={article.title_ar} className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 mx-auto max-w-3xl px-6 pb-8">
            <span className="mb-2 inline-block rounded-full bg-ivory/15 px-3 py-1 text-xs font-semibold text-ivory backdrop-blur">من تراثنا</span>
            <h1 className="font-display text-3xl font-bold text-ivory sm:text-4xl">{article.title_ar}</h1>
          </div>
        </div>
        <div className="mx-auto max-w-3xl px-6 py-12">
          <p className="text-lg leading-loose text-ink/75">{article.body_ar}</p>
          {article.is_demo && <p className="mt-6 text-sm text-ink/40">محتوى تجريبي — يُستبدل بمقالات موثقة من الإدارة.</p>}
          <Link to="/heritage" className="mt-10 inline-flex items-center gap-1.5 font-medium text-olive link-underline"><ArrowRight className="h-4 w-4" /> كل المقالات</Link>
        </div>
      </article>
    );
  }

  return (
    <div className="min-h-screen pt-24">
      <div className="border-b border-olive/10 bg-sand/30">
        <div className="mx-auto max-w-7xl px-6 py-12">
          <span className="mb-2 inline-block rounded-full bg-olive/8 px-3 py-1 text-xs font-semibold text-olive">من تراثنا</span>
          <h1 className="font-display text-3xl font-bold text-ink sm:text-4xl">حكايات من الأرض</h1>
          <p className="mt-2 max-w-xl text-ink/55">مقالات قصيرة موثقة عن الزيتون والزعتر والمونة والضيافة والمطبخ الفلسطيني.</p>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="grid gap-6 md:grid-cols-3">
          {list.map((h) => (
            <Link key={h.slug} to={`/heritage/${h.slug}`} className="group block overflow-hidden rounded-3xl border border-black/5 bg-white transition-shadow hover:shadow-lg">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={h.image} alt={h.title_ar} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-5">
                <h3 className="font-display text-lg font-semibold text-ink group-hover:text-olive">{h.title_ar}</h3>
                <p className="mt-2 text-sm text-ink/55">{h.excerpt_ar}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
